import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsConditions } from "./pages/TermsConditions";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ContactPopup } from "./components/ContactPopup";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Header onOpenPopup={() => setIsPopupOpen(true)} />
        <Routes>
          <Route path="/" element={<Home onOpenPopup={() => setIsPopupOpen(true)} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
        <Footer onOpenPopup={() => setIsPopupOpen(true)} />
        <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
